import { Table } from '@tanstack/react-table'
import ReactDragListView from 'react-drag-listview/lib/index.js'
import { useTranslation } from 'react-i18next'
import { DropdownItem, DropdownMenu, DropdownToggle, Label, UncontrolledDropdown } from 'reactstrap'
import SimpleBar from 'simplebar-react'

interface ColumnSettingsDropdownProps<TData> {
    table: Table<TData>
}

const ColumnSettingsDropdown = <TData,>({ table }: ColumnSettingsDropdownProps<TData>) => {
    const { t } = useTranslation()

    const centerColumns = table.getCenterLeafColumns()

    const dragProps = {
        onDragEnd(fromIndex: number, toIndex: number) {
            if (fromIndex === toIndex) return

            const centerIds = centerColumns.map((c) => c.id)
            const [moved] = centerIds.splice(fromIndex, 1)
            centerIds.splice(toIndex, 0, moved)

            const leftIds = table.getLeftLeafColumns().map((c) => c.id)
            const rightIds = table.getRightLeafColumns().map((c) => c.id)

            table.setColumnOrder([...leftIds, ...centerIds, ...rightIds])
        },
        nodeSelector: 'label',
        handleSelector: 'label',
    }

    return (
        <UncontrolledDropdown className="ms-2">
            <DropdownToggle title={t('table.columns')} onClick={(e) => e.preventDefault()} href="#" className="btn btn-primary dropdown" tag="button">
                <i className="mdi mdi-format-list-bulleted-square pe-none align-middle"></i>
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end" end={true}>
                <SimpleBar style={{ maxHeight: '400px', width: '300px', overflowX: 'hidden' }}>
                    <ReactDragListView {...dragProps}>
                        {centerColumns.map((column) => (
                            <DropdownItem
                                key={column.id}
                                for={column.id}
                                tag={Label}
                                toggle={false}
                                style={{ cursor: 'move' }}
                                className="d-flex align-items-center justify-content-between"
                            >
                                <div className="form-check">
                                    <input
                                        type="checkbox"
                                        id={column.id}
                                        name={column.id}
                                        checked={column.getIsVisible()}
                                        onChange={column.getToggleVisibilityHandler()}
                                        className="form-check-input"
                                    />{' '}
                                    {typeof column.columnDef.header === 'function' ? column.id : (column.columnDef.header as string)}
                                </div>
                                <i className="ms-2 mdi mdi-menu fs-16" style={{ color: '#CED4DA' }}></i>
                            </DropdownItem>
                        ))}
                    </ReactDragListView>
                </SimpleBar>
            </DropdownMenu>
        </UncontrolledDropdown>
    )
}

export default ColumnSettingsDropdown
